export default __webpack_public_path__ + "static/media/dr_kiss_pipa.e49000c1.svg";